import {Injectable} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, take} from 'rxjs/operators';
import {FirebaseNotificationService} from "../firebase-notification/firebase-notification.service";

@Injectable({
  providedIn: 'root'
})
export class RouteListenerService {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private firebaseNotificationService: FirebaseNotificationService,
  ) {
  }

  subscribeForWebNotificationId(): void {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      take(1)
    ).subscribe(async () => {
      const urlTree = this.router.parseUrl(this.router.url);
      const webNotificationId = urlTree.queryParams['webNotificationId'];

      if (webNotificationId) {
        await this.firebaseNotificationService.updateNotification(webNotificationId, {isRead: true});

        const newUrlTree = this.router.createUrlTree([], {
          relativeTo: this.activatedRoute,
          queryParams: { ...urlTree.queryParams },
          queryParamsHandling: 'merge'
        });

        delete newUrlTree.queryParams['webNotificationId'];

        await this.router.navigateByUrl(newUrlTree, { replaceUrl: true });
      }
    });
  }
}
